import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  tableOfContents: {
    defaultMessage: `Table of Contents`,
  },
});
